import React from "react";
import Loading from "../../component/Loading/Loading";
import SmallBox from "../../component/Box/SmallBox";
import TransactionService from "../TransactionService";

class DashboardTotalTransaction extends React.Component {

  transactionService = new TransactionService();

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.transactionService.countLastWeek().then(
        (data) => this.setState({total: data.total, loading: false})
    ).catch(
        () => this.setState({message: 'Falha ao carregar', loading: false})
    )
  }

  render() {
    const {loading} = this.props;
    if (loading) {
      return <Loading/>
    }
    let value = this.state.total;
    let message = 'Movimentações da semana';

    if (this.state.message) {
      value = 0;
      message = this.state.message;
    }

    return (
        <SmallBox secondary icon="exchange">
          <h3>{value}</h3>
          <p>{message}</p>
        </SmallBox>
    );
  }

}

export default DashboardTotalTransaction;



// WEBPACK FOOTER //
// ./src/transaction/component/DashboardTotalTransaction.js